import { FC } from 'app/FunctionalComponent'
import React from 'react'
import styles from './ApiExamples.module.scss'

export const MenuItem: FC = (props: {
	children: React.ReactNode
	menu: string
	isSelected: boolean
	onClick: () => void
}) => {
	let className = styles.menuItem
	if (props.isSelected) {
		className += ' ' + styles.selected
	}

	return (
		<div className={className} onClick={props.onClick}>
			{props.children}
		</div>
	)
}
